/**
 * Gráfico de volume por hora da fila financeira PGMQ
 * Exibe completados vs falhas nas últimas 24 horas
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useFinancialQueueVolume } from '@/hooks/useFinancialQueueMonitor';

export function FinancialQueueVolumeChart() {
  const { data: volumeData, isLoading } = useFinancialQueueVolume(24);

  if (isLoading) {
    return (
      <Card><CardHeader><CardTitle>Volume por Hora (24h)</CardTitle></CardHeader>
        <CardContent><Skeleton className="h-[300px] w-full" /></CardContent></Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">📊 Volume por Hora (24h)</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={volumeData || []}>
            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
            <XAxis dataKey="hour" fontSize={12} tickLine={false} axisLine={false} />
            <YAxis fontSize={12} tickLine={false} axisLine={false} />
            <Tooltip contentStyle={{ backgroundColor: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: '8px' }} />
            <Legend />
            <Bar dataKey="completed" name="Completados" fill="hsl(142, 76%, 36%)" radius={[4, 4, 0, 0]} />
            <Bar dataKey="failed" name="Falhas" fill="hsl(0, 84%, 60%)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
